<template>
    <Modal :show="show" :className="classOverride" :size="getCurrentSize" @close="close">

      <ModalSuccess v-if="success" title="Subscription successfully purchased" :bodyText="successBodyText" buttonText="OK" @close="closeSuccess()" />



      <div v-if="!success && currentPage === 0" class="page-0-content">

        <div class="modal-main text-center">
          <div class="modal-header row">
            <h2 class="col-12 modal-title">Choose a regular monitoring subscription option</h2>
          </div>
          <div class="modal-body w-100">
            <div class="row">

              <div class="col-12 col-md-4" v-for="product in products">
                <div class="priceCard planA pl-3 pr-3" :class="{ 'selected' : selectedSub && selectedSub.id === product.id }" @click.prevent="selectedSub = product">
                  <div class="text-orange price">${{ product.price }} <small>per kit</small></div>
                  <div class="priceQty">{{ product.qtyName }}</div>
                  <div class="qtyDescription">{{ product.qtyDescription }}</div>
                  <div v-html="product.description"></div>
                  <div>
                    <a class="btn btn-outline-primary" href="#">Choose option</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <button class="btn btn-primary mb-0" v-on:click="trackAndProceed">Proceed</button>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="modal-main w-100" v-if="!success && currentPage == 1">

          <div class="modal-header row">

            <h2 class="col-12 modal-title">Payment method</h2>
            <div class="col-12 text-center" style="font-size:16px; margin-top:20px;">
              Microba does not store this information it is sent directly to our payment<br/>
              partner, Stripe. Your purchase confirmation will be emailed to you from<br/>
              Stripe and Microba.
            </div>

          </div>

          <div class="modal-body w-100">

            <transition name="slide-fade">
              <div v-if="error" class="alert alert-danger" role="alert">
                {{error}}
              </div>
            </transition>



            <div class="form-block">
              <div class="row ml-1 mr-1">

                  <div class="col-12">
                      <div class="row">

                          <div class="form-group col col-md-6">
                              <input
                                      type="text"
                                      class="form-control"
                                      v-validate="'required'"
                                      v-model="editedUser.firstName"
                                      required
                                      placeholder="First name" />
                          </div>
                          <div class="form-group col col-md-6">
                              <input
                                      type="text"
                                      class="form-control"
                                      v-validate="'required'"
                                      v-model="editedUser.lastName"
                                      required
                                      placeholder="Last name" />
                          </div>

                      </div>
                  </div>
              </div>

              <div class="row  ml-1 mr-1">
                  <div class="form-group col col-md-12">
                      <Card class='stripe-card form-control'
                            :class='{ complete }'
                            :stripe="PurchaseStripeKey"
                            :options='stripeOptions'
                            @change='onStripeChange'
                      />
                  </div>
              </div>
            </div>

            <div class="form-block">
              <div class="row">
                <div class="col-12" style="font-size:16px; line-height:30px;">
                  <div class="ml-3 mr-3 text-center">
                  You hereby authorise Microba to charge you automatically as per the
                  frequency of your subscription. If you don't cancel your subscription
                  before the offer ends (check your account page for details), you will
                  automatically be charged the standard price every {{this.selectedSub.id}} months until you cancel.
                  Full terms and instructions on how to change are available here.

                    <div class="form-checkbox ">
                      <input
                        v-model="subscriptionTerms"
                        type="checkbox"
                        name="subscriptionTerms"
                        id="subscriptionTerms"
                      />
                      <label class="small-label" for="subscriptionTerms" style="margin: 20px auto;">I agree to the&nbsp;<a href="#" target="_blank">Terms and Conditions</a></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">

              <Button
                class="btn btn-primary"
                @onClick="validatePay"
                text="Confirm payment"
                :loading="loading"
              />
              <button class="btn plain" v-on:click="currentPage = 0"><em>Back</em></button>
          </div>

      </div><!-- END PAGE 2 -->

    </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'
import ModalAddress from '@/components/models/components/ModalAddress'
import ModalSuccess from '@/components/models/components/ModalSuccess'
import UserMixins from '@/mixins/userProfile'
import PurchaseKit from '@/mixins/purchaseKits'
import { Card, createToken } from 'vue-stripe-elements-plus'
import Button from '@/components/elements/DynamicButton'
import microbaAnalytics from '@/services/microbaAnalytics'

export default {
  name: 'ModalSubscription',
  props: {
    show: Boolean,
    giveAway: Boolean,
    replacement: Boolean,
    title: String,
    kitID: String,
    heading: String,
    showIntro: {
      type: Boolean,
      default: true
    },
    copy: String,
    product: {
      type: Object,
      required: true,
      validator: function (value) {
        return typeof value.amount === 'number' &&
        typeof value.label === 'string' &&
        typeof value.orderType === 'string'
      }
    }
  },
  mixins: [ UserMixins, PurchaseKit ],
  extends: Modal,
  components: {
    Modal,
    ModalAddress,
    ModalSuccess,
    Button,
    Card
  },
  mounted: function () {
    this.editedUser = this.user
  },
  data: function () {
    return {
      isEditing: false,
      currentPage: (this.showIntro) ? 0 : 1,
      loading: false,
      subscriptionTerms: false,
      editedUser: {
        firstName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        suburb: '',
        postcode: ''
      },
      products: [
        {
          id: 3,
          price: 279,
          type: 'EVERY_THREE_MONTHS',
          qtyName: 'Every 3 months',
          qtyDescription: '(4 kits per 12 month period)',
          description: 'Ongoing subscription option. <br/> You will be mailed a sampling kit<br/> and billed every 3 months.<br/> You can cancel anytime.'
        },
        {
          id: 6,
          price: 299,
          type: 'EVERY_SIX_MONTHS',
          qtyName: 'Every 6 months',
          qtyDescription: '(2 kits per 12 month period)',
          description: 'Ongoing subscription option.<br/> You will be mailed a sampling kit<br/> and billed every 6 months.<br/> You can cancel anytime.'
        },
        {
          id: 12,
          price: 315,
          type: 'EVERY_TWELVE_MONTHS',
          qtyName: 'Every 12 months',
          qtyDescription: '(1 kit per 12 month period)',
          description: 'Ongoing subscription option.<br/> You will be mailed a sampling kit<br/> and billed every 12 months.<br/> You can cancel anytime.'
        }
      ],
      selectedSub: null,
      qty: 1,
      complete: false,
      stripeComplete: false,
      success: false,
      error: null
    }
  },
  computed: {
    successBodyText () {
      if (this.replacement) {

      } else {
        return "You have successfully purchased a subscription for ongoing monitoring. Your first kit is on its way. This kit will now appear in the 'My Kits' page where you can view its progress."
      }
    },

    getTotalPrice () {
      let price = this.product.amount

      return (this.qty * price)
    },
    user: function () {
      return this.$store.state.GET_USER_RESPONSE || false
    },
    stripeOptions: function () {
      return {
        displayItems: [this.product],
        style: {
          base: {
            // Add your base input styles here. For example:
            'fontSize': '16px'
          }
        }
      }
    },
    purchaseObject: function () {
      let kitDtos = [{
        orderItemType: 'SUBSCRIPTION',
        subscriptionType: this.selectedSub.type,
        deliveryOption: 'SEND_NOW_MY_ADDRESS',
        unitPrice: this.selectedSub.price,
        email: this.user.email,
        deliveryAddress: {
          addressLine1: this.user.addressLine1,
          addressLine2: this.user.addressLine2,
          suburb: this.user.suburb,
          state: this.user.state,
          postcode: this.user.postcode
        }
      }]

      return (this.user) ? {
        purchaserEmail: this.user.email,
        purchaserFirstName: this.user.firstName,
        purchaserLastName: this.user.lastName,
        orderType: 'NEW',
        replacingKitId: this.kitID,
        orderItems: kitDtos,
        amount: this.selectedSub.price
      } : null
    },
    classOverride: function () {
      return 'page-' + this.currentPage
    },
    getCurrentSize: function () {
      if (this.currentPage === 0) {
        return 'LARGE'
      }
      return 'NORMAL'
    }
  },
  methods: {

    closeSuccess () {
      this.$store.dispatch('getUserKits')
      this.$store.dispatch('getUserSubscription')
      this.$router.push('kits')
      this.$emit('close')
    },
    formatMoney (val) {
      return val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    qtyIncrease () {
      this.qty++
    },

    qtyDecrease () {
      if (this.qty > 1) {
        this.qty --
      }
    },
    onShow: function () {
      this.loading = false
      this.editedUser = Object.assign({}, this.user)
      this.currentPage = (this.showIntro) ? 0 : 1
      this.complete = false
      this.stripeComplete = false
      this.success = false
      this.qty = 1
      this.isEditing = false
      this.subscriptionTerms = false
    },
    validatePay: function () {
      if (this.loading) {
        return
      }

      this.loading = true
      if (this.errors.any() || !this.isValidAddress(this.editedUser) || !this.stripeComplete) {
        this.loading = false
        this.error = 'Please complete credit card information.'
      } else {
        if (!this.subscriptionTerms) {
          this.loading = false
          this.error = 'Please agree to our Terms and Conditions.'
        } else {
          this.pay()
        }
      }
    },
    onStripeChange: function (e) {
      this.stripeComplete = e.complete
    },
    trackAndProceed: function () {
      microbaAnalytics.trackItemsAdded(this.selectedSub.id, `Microba ${this.selectedSub.id} month subscription`, this.selectedSub.price, this.qty, this.selectedSub.type, '')
      this.currentPage = 1
    },
    pay: function () {
      createToken().then(data => {
        if (data.error) {
          this.error = data.error.message
        } else {
          const stripeToken = data.token.id
          const description = this.product.label
          const payload = {...this.purchaseObject, stripeToken, description}
          this.error = null
          this.success = false
          this.$store.dispatch('postOrder', payload).then(success => {
            microbaAnalytics.trackPurchase(stripeToken, this.selectedSub.id, `Microba ${this.selectedSub.id}  month subscription`, this.selectedSub.price, this.qty, this.selectedSub.type, '', this.selectedSub.price)
            // Activate the kit after purhcase
            this.$store.dispatch('getUserKits')
            this.$store.dispatch('getUserSubscription')
            this.$store.dispatch('getSentKits')
            this.loading = false
            this.success = true
            this.error = null

//            const activatePayload = {
//              kitId: success.data.id
//            }
//            this.$store.dispatch('activateKit', activatePayload).then(success => {
//              this.loading = false
//              this.success = true
//              this.error = null
//
//
//            })
          }).catch(error => {
            console.log(error)
            this.loading = false
            this.success = false

            // Refresh regardless
            this.$store.dispatch('getUserKits')
            this.$store.dispatch('getSentKits')
            this.$store.dispatch('getUserSubscription')

            // Map some specific errors or return server message
            switch (error.response.status) {
              case 402:
                this.error = 'Your credit card transaction has been rejected.'
                break
              case 500:
                this.error = 'We have experienced some technical issue with payment. Please try again. If problem persist, please contact us at 1300 974 621.'
                break
              default:
                this.error = error.response.data.message
            }
          })
        }
      }).catch(error => {
        this.error = error.response.data.message
      })
    }
  }
}
</script>

 <style scoped lang="scss">

   .qtyBox {
     background: #f2f2f2;
     margin-bottom:20px;
     height:  52px;
     span{
       width: 100%;
       font-size: 24px;
       text-align: center;
       padding-top: 8px;
     }
     a {
       border-radius: 10px;
       background: #589eca;
       color: #dbebf4;
       border: none;
       font-size: 24px;
       padding: 8px 0px;
        width:48px;
       text-align:center;

       &.btnSub{
        position: absolute;
         left:0;
         top:0;

       }
       &.btnAdd{
         position: absolute;
         right:0;
         top:0;
       }
     }
   }
   .totalTitle{
     font-weight:lighter;
     font-size:26px;
   }

   .totalValue{
     font-weight:normal;
     font-size:26px;
   }



    .form{
        padding-top: 1rem;
        margin-top: 1rem;
    }

    #totalBox{
         padding-top: 40px;
         padding-bottom: 36px;
         background: #f4f4f4;
         margin-bottom: 26px;
    }

    #totalBox .btn-sm{
        padding: 0.025rem 0.5rem;
        border-radius: 3px;
    }
    #totalBox .qtyValue {
        width: calc(100% - 60px);
        text-align: center;
        padding-top: 3px;
    }

    #totalBox .qtyValueReplace {
        width: 100%;
        text-align: center;
        padding-top: 3px;
    }

    #totalBox .qtyValueTitle {
        padding-top: 3px;
    }

    #totalBox .qtyBox {
        border:1px solid #dbdbdb;
        padding:5px;
    }

     #totalRow{
         background:#fff;
         border:1px solid #dbdbdb;
         margin-top:20px;
     }

     .totalRowPadding{
         margin-left:40px;
         margin-right:40px;
         padding-top:15px;
         padding-bottom:15px;
     }

   .priceCard:hover{
     background: #fce9d8 !important;
   }

    .priceCard{
      border:1px solid #e4e7ea;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      cursor:pointer;

      &.selected{
        background: #f4f4f4 !important;
        color: #b7bdc5;

        .price{
          color: #b7bdc5;
        }
        a{
          border-color: #b7bdc5;
          color: #b7bdc5;
          background: none !important;
        }
      }

      .price{
        font-size:22px;
        font-weight: 500;
        margin-top:20px;
        margin-bottom:20px;
      }

      .priceQty{
        font-size:16px;
        font-weight: 600;
      }

      .qtyDescription{
        font-size:16px;
        margin-bottom:20px;
      }

      .btn{
        margin-top:30px !important;
        margin-bottom:30px !important;
      }

    }


 </style>



// WEBPACK FOOTER //
// src/components/models/ModalSubscription.vue